import ApplicationController from "../application_controller.js";

export default class extends ApplicationController {

  static values = {
    max: { type: Number, default: 200 },
    separator: { type: String, default: " / " },
    align: { type: String, default: "right" },
    colors: { type: Array, default: ["#666666", "#6D5555", "#793535", "#841C1C", "#841C1C", "#841C1C", "#8F0001"] },
    fontWeights: { type: Array, default: ["normal", "normal", "normal", "normal", "normal", "normal", "bold"] },
    thresholds: { type: Array, default: [50, 60, 70, 80, 90, 100, Number.MAX_VALUE] },
  };

  initialize() {
    this.log_function("initialize");

    this.checkInit();

    //* The initialize attaches this structure after the input target
    //* <div>
    //*   <span>0</span>
    //*   <span> / </span>
    //*   <span> 200 </span>
    //* </div>

    //* Creates the elements
    this.container_element = document.createElement("div");
    this.current_element   = document.createElement("span");
    this.separator_element = document.createElement("span");
    this.maximum_element   = document.createElement("span");

    //* Set Span contents
    this.current_element.innerHTML   = this.characterCount;
    this.separator_element.innerHTML = this.separatorValue;
    this.maximum_element.innerHTML   = this.max;

    //* Nests the spans in the div element
    this.container_element.appendChild(this.current_element);
    this.container_element.appendChild(this.separator_element);
    this.container_element.appendChild(this.maximum_element);

    //* Set Styling
    this.container_element.style.float = this.alignValue;
    this.separator_element.style.color = this.colorsValue[0];

    //* Attaches the div element after the input target
    //* Source: https://www.javascripttutorial.net/javascript-dom/javascript-insertafter
    this.element.parentNode.insertBefore(this.container_element, this.element.nextSibling);
  }

  connect() {
    this.log_function("connect");

    this.setCount();
    this.setStyle();

    //* Setup Event Listener
    this.boundHandleTyping = this.handleTyping.bind(this);
    this.element.addEventListener("input", this.boundHandleTyping);
  }

  handleTyping(){
    this.log_function("handleTyping");

    this.setCount();
    this.setStyle();
  }

  //* Set the look of the counter
  setStyle() {
    this.log_function("setStyle");

    const level = this.warning_level;
    const color = this.colorsValue[level];
    const fontWeight = this.fontWeightsValue[level];

    this.container_element.style.fontWeight = fontWeight;
    this.current_element.style.color = color;
    this.maximum_element.style.color = color;
  }

  //* Update Character count on screen
  setCount(){
    this.log_function("setCount");

    this.current_element.innerHTML = this.characterCount;
  }

  //* Check for human error in the settings provided
  checkInit() {
    this.log_function("checkInit");

    const colorLength       = this.colorsValue.length;
    const fontWeightsLength = this.fontWeightsValue.length;
    const thresholdsLength  = this.thresholdsValue.length;

    //* Check if the values are enough
    if(colorLength === fontWeightsLength && fontWeightsLength === thresholdsLength) {
      this.log_function("checkInit", `👍 The colors, fontWeights, thresholds arrays match in length (${colorLength})`);
    }else {
      this.log_function(
        "checkInit",
        `👎 The colors(${colorLength}), fontWeights(${fontWeightsLength}), thresholds(${thresholdsLength}) arrays DON'T match in length`,
      );
    }
  }

  disconnect(){
    this.log_function("disconnect");

    //* Remove event listener
    this.element.removeEventListener("input", this.boundHandleTyping);
    //* Remove the container from the page so it wont get duplicated by turbo
    this.container_element.remove();
  }

  //* Return the maximum value as an integer
  get max() {
    this.log_function("get max");

    return parseInt(this.maxValue);
  }

  //* Return the input character count as an integer
  get characterCount() {
    this.log_function("get characterCount");

    return this.element.value.length;
  }

  //* Return the input capacity used as a float
  get fillPercent() {
    this.log_function("get fillPercent");

    const count = this.characterCount;
    const max = this.max;
    return (count / max) * 100;
  }

  //* Retrun the warning level as a integer
  get warning_level() {
    this.log_function("get warning_level");

    const percent = this.fillPercent;
    const level = this.thresholdsValue.findIndex( threshold => percent <= threshold);
    return level;
  }
}
